import React, { useEffect, useRef } from 'react'
import { Button } from 'react-bootstrap'
import Floatingbutton from './Floatingbutton'
import Conformationdeleteform from '../Modals/Conformationdeleteform'
import { connect } from 'react-redux'
import FormBuilder from '../Elements/FormBuilder'
import Openformmodal from '../Modals/Openformmodal'
import config from '../../config'
import axios from 'axios'
import { toast } from 'react-toastify'

function FormsPage({ userAccess }) {
  const wideBlockRef = useRef()

  const [showConfirmModal, setShowConfirmModal] = React.useState(false)
  const [deleteId, setDeleteId] = React.useState(null)
  const [showModal, setShowModal] = React.useState(false)
  const [selectId, setSelectId] = React.useState(null)
  const [inputData, setInputData] = React.useState([])
  const [formItems, setformItems] = React.useState([])

  useEffect(() => {
    if (showModal) {
      fetchinputs()
    }
  }, [showModal])

  useEffect(() => {
    getforms()
  }, [])

const handleFormSave = formJSON => {
    setformItems(prev => [
      {
        id: Date.now(),
        ...formJSON
      },
      ...prev
    ])

  }

  const fetchinputs = async () => {
    const token = localStorage.getItem('token')

    try {
      const res = await axios.get(
        `${config.apiUrl}/projects/projects-with-wings`,
        {
          headers: { Authorization: token }
        }
      )
      console.log('FULL API RESPONSE:', res.data)
      const normalized = (res.data || []).flatMap(project =>
        (project.Wings || []).map(wing => ({
          projectId: project.ID,
          projectName: project.Name.trim(),
          wingId: wing.ID,
          wingName: wing.Name
        }))
      )
      setInputData(normalized)
    } catch (err) {
      console.error(err)
      toast.error('Failed to fetch posts')
    }
  }

  const getforms = async () => {
    const token = localStorage.getItem('token')
    try {
      const res = await axios.get(`${config.apiUrl}/post/Form`, {
        headers: { Authorization: token }
      })
      console.log('FULL API RESPONSE:', res.data)
      const normalized = (res.data.data || []).map(form => {
        const data = form.Data || {}
        return {
          CreatedOn: form?.CreatedOn || new Date().toISOString(),
          postId: form.ID,
          formId: data.FormID,         
          id: data.FormID,
          title: data.title || '',
          description: data.description || '',
          submitButtonText: data.submittext || 'Submit',
          CreatedOn: form.CreatedOn,
          fields: (data.fields || []).map((field, index) => ({
            id: `${data.FormID}-${index}`,
            type: field.type,
            label: field.label,
            placeholder: field.placeholder,
            required: field.required,
            options: field.options || []
          }))
        }
      })
      normalized.sort((a, b) => b.postId - a.postId)
      setformItems(normalized)
      console.log('Data', {normalized})
    } catch (err) {
      console.error(err)
    }
  }

  const handleConfirmDelete = async () => {
  if (!deleteId) return;

  const token = localStorage.getItem('token');

  try {
    await axios.delete(`${config.apiUrl}/post/${deleteId}`, {
      headers: {
        Authorization: token,
        'Content-Type': 'application/json',
      },
    });

    setformItems(prev =>
      prev.filter(item => item.postId !== deleteId)
    );

    toast.success('Form deleted successfully!');
    setShowConfirmModal(false);
    setDeleteId(null);
  } catch (e) {
    console.error(e);
    toast.error('Failed to delete poll');
  }
};

  

  const handleCancelDelete = () => {
    setShowConfirmModal(false)
    setDeleteId(null)
  }

  const handlemodalOpen = id => {
    setSelectId(id)
    setShowModal(true)
    console.log('Floating clicked')
  }

  const handleDeleteModal = postId => {
  setDeleteId(postId)           
  setShowConfirmModal(true)
}

  useEffect(() => {
    const updateHeight = () => {
      const fullHeight = window.innerHeight
      const offset = 100 // adjust this based on your header or spacing
      if (wideBlockRef.current) {
        wideBlockRef.current.style.maxHeight = `${fullHeight - offset}px`
      }
    }
    updateHeight()
    window.addEventListener('resize', updateHeight)

    return () => window.removeEventListener('resize', updateHeight)
  }, [])
  return (
    <div id="appCapsule">
      <div class="section full mt-1">
        {/* <div class="section-title fw-bold fs-6">Updates</div> */}

        <div class="wide-block mt-1" ref={wideBlockRef}>
          {/* <!-- timeline --> */}
          <div class="timeline timed">
            {formItems.map(item => (
              <div class="item" key={item.id}>
                <span class="time">
                  {item.CreatedOn
                    ? new Date(item.CreatedOn).toLocaleDateString('en-IN', {
                        day: '2-digit',
                        month: 'short',
                        year: 'numeric'
                      })
                    : '--'}
                  <br />
                  {item.CreatedOn
                    ? new Date(item.CreatedOn).toLocaleTimeString('en-IN', {
                        hour: '2-digit',
                        minute: '2-digit',
                        hour12: true
                      })
                    : '--'}
        
                </span>
                <div class="dot bg-black"></div>
                <div class="content">
                  <div
                    className="card p-3 position-relative"
                    style={{ backgroundColor: '#f1f1f1' }}
                  >
                    {userAccess.includes('DeleteForm') && (
                      <div
                        className="rounded-circle position-absolute top-0 end-0 p-2"
                        style={{
                          backgroundColor: 'red',
                          boxShadow: '0 2px 2px rgba(0,0,0,0.2)',
                          cursor: 'pointer',
                          zIndex: 10,
                          width: '56px',
                          height: '56px'
                        }}
                        onClick={() => handleDeleteModal(item.postId)}
                      >
                        <ion-icon
                          name="trash"
                          style={{
                            fontSize: '24px',
                            color: 'white',
                            cursor: 'pointer'
                          }}
                        ></ion-icon>
                      </div>
                    )}
                    <h4 className="title mb-2">{item.title}</h4>
                    <p className="text">{item.description}</p>
                    {item.fields.map(f => (
                      <div key={f.id} style={{ marginBottom: 10 }}>
                        <div className="w-100">
                          <label className="form-label">
                            {f.label} {f.required ? '*' : ''}
                          </label>
                        </div>

                        {f.type === 'text' && (
                          <input className="form-control" />
                        )}
                        {f.type === 'number' && (
                          <input className="form-control" type="number" />
                        )}
                        {f.type === 'textarea' && (
                          <textarea className="form-control" />
                        )}
                        {f.type === 'date' && (
                          <input className="form-control" type="date" />
                        )}
                        {f.type === 'datetime' && (
                          <input
                            className="form-control"
                            type="datetime-local"
                          />
                        )}

                        {(f.type === 'radio' || f.type === 'checkbox') &&
                          f.options &&
                          f.options.length > 0 &&
                          f.options.map((o, i) => (
                            <div className="form-check" key={i}>
                              <input
                                className="form-check-input"
                                type={f.type}
                                name={
                                  f.type === 'checkbox' ? `${f.id}[]` : f.id
                                }
                                id={`${f.id}_${i}`}
                              />
                              <label
                                className="form-check-label"
                                htmlFor={`${f.id}_${i}`}
                              >
                                {o}
                              </label>
                            </div>
                          ))}

                        {f.type === 'select' && (
                          <select className="form-control">
                            <option value="">Select</option>
                            {f.options?.map((o, i) => (
                              <option key={i}>{o}</option>
                            ))}
                          </select>
                        )}
                      </div>
                    ))}

                    <button type="submit" className="btn btn-primary">
                      {item.submitButtonText || 'Save'}
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        {userAccess.includes('CreateForm') && (
          <Floatingbutton onOpen={handlemodalOpen} />
        )}

        <Openformmodal
          show={showModal}
          userId={selectId}
          onClose={() => setShowModal(false)}
          inputData={inputData}
          onSave={handleFormSave}
          getforms={getforms}
        />

        <Conformationdeleteform
            show={showConfirmModal}
            onClose={handleCancelDelete}
            onConfirm={handleConfirmDelete}
        />
      </div>
    </div>
  )
}
const mapStateToProps = ({ auth }) => {
  const { userAccess } = auth
  return {
    userAccess
  }
}
const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(FormsPage)
